import { KeywordsBreakdownWidget } from "../keywords-breakdown-widget";
import { SearchVolumeOverTimeWidget } from "../search-volume-over-time-widget";
import { TrafficByCountry } from "../traffic-by-country";

import { DemandOverTime } from "./demand-over-time/DemandOverTime";

const SearchTrendsAiTopicPoP = () => {
    return (
        <>
            <SearchVolumeOverTimeWidget />
            <TrafficByCountry />
            <DemandOverTime />
            <KeywordsBreakdownWidget isPeriodOverPeriod />
        </>
    );
};

export default SearchTrendsAiTopicPoP;
